import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    data(){return {
        //contacts: [],
        contactReady: false,
        contactLocal: {},
        formContactDate: null,
        deflts: ["emails","phones","addresses",],
        filtersValues: {
            search: null,
            role: null,
        },
    }},
    props: {
        contact: { type: Object, default(){ return {} }, },
        emitContact: { type: Boolean },
        contactNamedId: { type: String },
    },
    async mounted(){
        if(this.meetingNamedId){
            const response = await this.getCurrentContact(this.contactNamedId);
            this.contactLocal = response.data;
        }
        this.contactReady = true;
    },
    emits: ['selected-contact',],
    computed: {
        ...mapState("Addressbook", ["currentContact", "listContact", "contactslist", "currentRepFor", "currentRepBy"]),
        ...mapGetters("Addressbook", ["getContactsResult", "apiUrlAddressbook"]),
        contactLoad(){
            if(this.contactNamedId)
                return this.meetingLocal;
            else if(this.has(this.contact))
                return this.contact;
            else if(!this.currentContact && this.contactUid)
                this.loadContact();
            return this.currentContact;
        },
        //contactUid(){ return this.has(this.contactLoad) ? this.contactLoad.uid : this.$route.params.contactUid; },
        contactRolesUid(){ return this.contactLoad.roles; },
        contactGender(){
            if(this.contactLoad.gender == "W")
                return "venus";
            if(this.contactLoad.gender == "M")
                return "mars";
            if(this.contactLoad.gender == "C")
                return "building";
        },
        excludeCurrentContact(){
            var params = {};
            if(this.contactLoad.uid)
                params['-uid'] = [this.contactLoad.uid];
            return params;
        },
        excludeCurrentRoles(){
            var params = {};
            if(this.contactLoad.roles)
                params['-uid'] = this.contactRolesUid;
            return params;
        },
        firstDeflt() {
            var deflt;
            this.deflts.every(el => {
                deflt = this.deflt(el);
                if (deflt) {
                    return false;
                }
                return true;
            });
            return deflt;
        },
        searchFilter: {
            get() { return this.filtersValues.search; },
            set(search) {
                this.filtersValues.search = search.value;
                this.loadContacts();
            },
        },
        roleFilter: {
            get() { return this.filtersValues.role; },
            set(role) {
                this.filtersValues.role = role.value;
                this.loadContacts();
            },
        }
    },
    methods: {
        ...mapActions("Addressbook", [
            "getCurrentContact",
            "setCurrentContact",
            "getListContact",
            "setListContact",
            "reloadListContact",
            "updateContact",
            "createContact",
            "deleteContact",
            "setCurrentContactAsMe",
        ]),
        urlListContact(){ return {name: "addressbook"}; },
        urlDetailContact(ct) { return {name: "detail-contact", params: {contactUid: ct.uid}}; },
        goOnAddressBook(){ this.$router.push(this.urlListContact()); },
        goOnDetail(ct){ this.$router.push(this.urlDetailContact(ct)); },
        validFormContact(){ this.formContactDate = Date.now(); },
        cancelFormContact(){ history.back(); },
        urlAPIContact(add){
            return add ? this.apiUrlAddressbook("contact")+add : this.apiUrlAddressbook("contact");
        },
        async createOrUpdateContact(contact){
            if(contact.uid)
                this.editContact({uid: contact.uid, payload: contact});
            else
                this.createContact(contact);

        },
        async isValidFormContact(payload){
            payload.group = this.tenantParams().group;
            if(this.has(this.contactLoad))
                await this.updateContact({uid: this.contactUid, payload: payload});
            else
                await this.addContact(this.payload(payload));
        },
        deflt(type) {

            var deflt = this.contact[type] ? this.contact[type].find(el => el.default === true) : false;
            if (deflt) {
                if(type == 'emails') return deflt.email;
                else if(type == 'phones') return deflt.phone;
                else if(type == 'addresses')return deflt.representation;
            }
            else if(this.contact[type]) {
                return this.contact[type][0];
            }
            return '';
        },
        contactParams(params){
            params = params !== undefined ? params : {};
            params = Object.assign(params, this.tenantParams());
            if(this.searchFilter)
                params.search = this.searchFilter;
            if(this.roleFilter)
                params.role = this.roleFilter;
            return params;
        },
        async saveContact(payload, ){
            payload.group = this.tenantParams().group;
            const resp = await this.addContact(payload);
            if(this.emitContact){ this.$emit('selected-contact', resp)}
            else{ this.$router.push({name: 'addressbook'}); }
        },
        //async loadContact(){
        //    if(!this.contactReady) await this.getContact(this.contactUid);
        //},
        //async loadContacts(){
        //    await this.getContacts(this.getPayload(this.contactParams()))
        //}

        async searchContactsLocal(pl){
            pl = pl != undefined ? pl : {};
            const response = await this.getListContact(this.payloadGET(pl));
            this.contacts = response.data.results;
        }
    }
}
